module.exports = __webpack_public_path__ + "img/warning.efd7b3aa.svg";